// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20d48137","611":"776c9eb1","742":"a8101993","869":"5bcc7793"}[chunkId] + ".chunk.js";
};